import { SignatureType } from '../services/types';

type SearchSignaturesParams = {
  signatures: SignatureType[],
  queryTokens: string[],
}

const replaceRegex = /[^a-zA-Z0-9 ]/g;
const replaceValue = '\\$&';
export const filterSignatues = ({
  signatures,
  queryTokens,
}: SearchSignaturesParams) => {
  const regexSearchQuery = new RegExp(`(${queryTokens?.join('|')})`);

  const filteredSignatures = signatures.filter((signature) => {
    if (regexSearchQuery.test(signature.file_description
      .toLowerCase()
      .replace(replaceRegex, replaceValue)
    )) {
      return true;
    }

    return false;
  });

  return filteredSignatures;
};